// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section-wrapper {
  border: 1px solid var(--g-color-line-generic);
  border-radius: 8px;
  padding: 20px;
}
.section-wrapper + .section-wrapper {
  margin-top: 20px;
}
.section-wrapper__title {
  font-family: var(--g-text-subheader-font-family);
  font-weight: var(--g-text-subheader-font-weight);
  font-size: var(--g-text-subheader-2-font-size);
  line-height: var(--g-text-subheader-2-line-height);
  font-weight: 500;
  margin-bottom: 20px;
}
.section-wrapper__title_with-subtitle {
  margin-bottom: 4px;
}
.section-wrapper__subtitle {
  color: var(--g-color-text-secondary);
  margin-bottom: 17px;
}
.section-wrapper__content + .section-wrapper__content {
  margin-top: 20px;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/SectionWrapper/SectionWrapper.scss","webpack://./node_modules/@gravity-ui/uikit/styles/mixins.scss"],"names":[],"mappings":"AAEA;EACI,6CAAA;EACA,kBAAA;EACA,aAAA;AADJ;AAGI;EACI,gBAAA;AADR;AAII;EC2NA,gDAAA;EACA,gDAAA;EACA,8CAAA;EACA,kDAAA;ED5NI,gBAAA;EACA,mBAAA;AACR;AACQ;EACI,kBAAA;AACZ;AAGI;EACI,oCAAA;EACA,mBAAA;AADR;AAII;EACI,gBAAA;AAFR","sourcesContent":[".section-wrapper {\n  border: 1px solid var(--g-color-line-generic);\n  border-radius: 8px;\n  padding: 20px;\n}\n.section-wrapper + .section-wrapper {\n  margin-top: 20px;\n}\n.section-wrapper__title {\n  font-family: var(--g-text-subheader-font-family);\n  font-weight: var(--g-text-subheader-font-weight);\n  font-size: var(--g-text-subheader-2-font-size);\n  line-height: var(--g-text-subheader-2-line-height);\n  font-weight: 500;\n  margin-bottom: 20px;\n}\n.section-wrapper__title_with-subtitle {\n  margin-bottom: 4px;\n}\n.section-wrapper__subtitle {\n  color: var(--g-color-text-secondary);\n  margin-bottom: 17px;\n}\n.section-wrapper__content + .section-wrapper__content {\n  margin-top: 20px;\n}",null],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
